import DealDTO from "@/models/DealDTO";

export function dealHasSbpQrPayload(deal: DealDTO | null | undefined): boolean {
  if (!deal) {
    return false;
  }
  const req = deal.requisites?.requisites;
  const link = deal.qrCodeLink;
  const hasReq = typeof req === "string" && req.trim().length > 0;
  const hasQrLink = typeof link === "string" && link.trim().length > 0;
  return hasReq || hasQrLink;
}

export function sbpPaymentOpenUrl(deal: DealDTO | null | undefined): string {
  if (!deal) {
    return "";
  }
  const req = deal.requisites?.requisites;
  if (typeof req === "string" && req.trim().length > 0) {
    return req.trim();
  }
  const link = deal.qrCodeLink;
  if (typeof link === "string" && link.trim().length > 0) {
    return link.trim();
  }
  return "";
}
